export interface Bq6CargoGearM {
  gearMakeType: string;
  noOfDerricksFitted: string;
  derricksSafeWorkingLoad: string;
  noOfCranesFitted: string;
  cranesSafeWorkingLoad: string;
  cranesLocation: string;
  maxOutreachShipSide: string;
  maxOutreachShipSideComments: string;
  maxOutreachBeyondRail: string;
  maxOutreachBeyondRailComments: string;
  hookMinClearanceDistance: string;
  hookFullCycleTime: string;
  hoistingTime: string;
  luffingTime: string;
  slewingTime: string;
  gearCombinableHeavyLift: string;
  gearCombinableHeavyLiftComments: string;
  winchesElectroHydraulic: string;
  winchesElectroHydraulicComments: string;
  grabTypeIfFitted: string;
  numberOfGrabsOnBoard: string;
  grabCapacity: string;
  grabsPowerAmps: string;
  grabsPowerVolts: string;
  enoughPowerForCranesGrabs: string;
  vesselFittedLights: string;
  vesselFittedLightsComments: string;
  vesselLogsFitted: string;
  logsFittedDetails: string;
  vesselLogRacksFitted: string;
  vesselLogRacksFittedComments: string;
  vesselLakesFitted: string;
  lakesNRT: string;
  lakesGRT: string;
  summerTimberDW: string;
  summerTimberDWComments: string;
  summerTimberDraft: string;
  summerTimberDraftComments: string;
  tpcSummerTimberDraft: string;
  winterTimberDW: string;
  winterTimberDraft: string;
  tpcWinterTimberDraft: string;
  winterNorthAtlanticDW: string;
  winterNorthAtlanticDraft: string;
  tpcWinterNorthAtlanticDraft: string;
  freshWaterTimberDW: string;
  freshWaterTimberDraft: string;
  tpcFreshWaterTimberDraft: string;
  tropicalTimberDW: string;
  tropicalTimberDraft: string;
  tpcTropicalTimberDraft: string;
  tropicalFreshWaterDW: string;
  tropicalFreshWaterDraft: string;
  tpcTropicalFreshWaterDraft: string;
}

export const initialBq6CargoGear: Bq6CargoGearM = {
  gearMakeType: "",
  noOfDerricksFitted: "",
  derricksSafeWorkingLoad: "",
  noOfCranesFitted: "",
  cranesSafeWorkingLoad: "",
  cranesLocation: "",
  maxOutreachShipSide: "",
  maxOutreachShipSideComments: "",
  maxOutreachBeyondRail: "",
  maxOutreachBeyondRailComments: "",
  hookMinClearanceDistance: "",
  hookFullCycleTime: "",
  hoistingTime: "",
  luffingTime: "",
  slewingTime: "",
  gearCombinableHeavyLift: "",
  gearCombinableHeavyLiftComments: "",
  winchesElectroHydraulic: "",
  winchesElectroHydraulicComments: "",
  grabTypeIfFitted: "",
  numberOfGrabsOnBoard: "",
  grabCapacity: "",
  grabsPowerAmps: "",
  grabsPowerVolts: "",
  enoughPowerForCranesGrabs: "",
  vesselFittedLights: "",
  vesselFittedLightsComments: "",
  vesselLogsFitted: "",
  logsFittedDetails: "",
  vesselLogRacksFitted: "",
  vesselLogRacksFittedComments: "",
  vesselLakesFitted: "",
  lakesNRT: "",
  lakesGRT: "",
  summerTimberDW: "",
  summerTimberDWComments: "",
  summerTimberDraft: "",
  summerTimberDraftComments: "",
  tpcSummerTimberDraft: "",
  winterTimberDW: "",
  winterTimberDraft: "",
  tpcWinterTimberDraft: "",
  winterNorthAtlanticDW: "",
  winterNorthAtlanticDraft: "",
  tpcWinterNorthAtlanticDraft: "",
  freshWaterTimberDW: "",
  freshWaterTimberDraft: "",
  tpcFreshWaterTimberDraft: "",
  tropicalTimberDW: "",
  tropicalTimberDraft: "",
  tpcTropicalTimberDraft: "",
  tropicalFreshWaterDW: "",
  tropicalFreshWaterDraft: "",
  tpcTropicalFreshWaterDraft: "",
};

export function mapSqlToBq6CargoGearForm(genInfo: any): Bq6CargoGearM {
  return {
    gearMakeType: genInfo?.GEAR_MAKE_TYPE || "",
    noOfDerricksFitted: genInfo?.NO_OF_DERRICKS_FITTED || "",
    derricksSafeWorkingLoad: genInfo?.DERRICKS_SAFE_WORKING_LOAD || "",
    noOfCranesFitted: genInfo?.NO_OF_CRANES_FITTED || "",
    cranesSafeWorkingLoad: genInfo?.CRANES_SAFE_WORKING_LOAD || "",
    cranesLocation: genInfo?.CRANES_LOCATION || "",
    maxOutreachShipSide: genInfo?.MAX_OUTREACH_SHIP_SIDE || "",
    maxOutreachShipSideComments: genInfo?.MAX_OUTREACH_SHIP_SIDE_COMMENTS || "",
    maxOutreachBeyondRail: genInfo?.MAX_OUTREACH_BEYOND_RAIL || "",
    maxOutreachBeyondRailComments: genInfo?.MAX_OUTREACH_BEYOND_RAIL_COMMENTS || "",
    hookMinClearanceDistance: genInfo?.HOOK_MIN_CLEARANCE_DISTANCE || "",
    hookFullCycleTime: genInfo?.HOOK_FULL_CYCLE_TIME || "",
    hoistingTime: genInfo?.HOISTING_TIME || "",
    luffingTime: genInfo?.LUFFING_TIME || "",
    slewingTime: genInfo?.SLEWING_TIME || "",
    gearCombinableHeavyLift: genInfo?.GEAR_COMBINABLE_HEAVY_LIFT || "",
    gearCombinableHeavyLiftComments: genInfo?.GEAR_COMBINABLE_HEAVY_LIFT_COMMENTS || "",
    winchesElectroHydraulic: genInfo?.WINCHES_ELECTRO_HYDRAULIC || "",
    winchesElectroHydraulicComments: genInfo?.WINCHES_ELECTRO_HYDRAULIC_COMMENTS || "",
    grabTypeIfFitted: genInfo?.GRAB_TYPE_IF_FITTED || "",
    numberOfGrabsOnBoard: genInfo?.NUMBER_OF_GRABS_ON_BOARD || "",
    grabCapacity: genInfo?.GRAB_CAPACITY || "",
    grabsPowerAmps: genInfo?.GRABS_POWER_AMPS || "",
    grabsPowerVolts: genInfo?.GRABS_POWER_VOLTS || "",
    enoughPowerForCranesGrabs: genInfo?.ENOUGH_POWER_FOR_CRANES_GRABS || "",
    vesselFittedLights: genInfo?.VESSEL_FITTED_LIGHTS || "",
    vesselFittedLightsComments: genInfo?.VESSEL_FITTED_LIGHTS_COMMENTS || "",
    vesselLogsFitted: genInfo?.VESSEL_LOGS_FITTED || "",
    logsFittedDetails: genInfo?.LOGS_FITTED_DETAILS || "",
    vesselLogRacksFitted: genInfo?.VESSEL_LOG_RACKS_FITTED || "",
    vesselLogRacksFittedComments: genInfo?.VESSEL_LOG_RACKS_FITTED_COMMENTS || "",
    vesselLakesFitted: genInfo?.VESSEL_LAKES_FITTED || "",
    lakesNRT: genInfo?.LAKES_NRT || "",
    lakesGRT: genInfo?.LAKES_GRT || "",
    summerTimberDW: genInfo?.SUMMER_TIMBER_DW || "",
    summerTimberDWComments: genInfo?.SUMMER_TIMBER_DW_COMMENTS || "",
    summerTimberDraft: genInfo?.SUMMER_TIMBER_DRAFT || "",
    summerTimberDraftComments: genInfo?.SUMMER_TIMBER_DRAFT_COMMENTS || "",
    tpcSummerTimberDraft: genInfo?.TPC_SUMMER_TIMBER_DRAFT || "",
    winterTimberDW: genInfo?.WINTER_TIMBER_DW || "",
    winterTimberDraft: genInfo?.WINTER_TIMBER_DRAFT || "",
    tpcWinterTimberDraft: genInfo?.TPC_WINTER_TIMBER_DRAFT || "",
    winterNorthAtlanticDW: genInfo?.WINTER_NORTH_ATLANTIC_DW || "",
    winterNorthAtlanticDraft: genInfo?.WINTER_NORTH_ATLANTIC_DRAFT || "",
    tpcWinterNorthAtlanticDraft: genInfo?.TPC_WINTER_NORTH_ATLANTIC_DRAFT || "",
    freshWaterTimberDW: genInfo?.FRESH_WATER_TIMBER_DW || "",
    freshWaterTimberDraft: genInfo?.FRESH_WATER_TIMBER_DRAFT || "",
    tpcFreshWaterTimberDraft: genInfo?.TPC_FRESH_WATER_TIMBER_DRAFT || "",
    tropicalTimberDW: genInfo?.TROPICAL_TIMBER_DW || "",
    tropicalTimberDraft: genInfo?.TROPICAL_TIMBER_DRAFT || "",
    tpcTropicalTimberDraft: genInfo?.TPC_TROPICAL_TIMBER_DRAFT || "",
    tropicalFreshWaterDW: genInfo?.TROPICAL_FRESH_WATER_DW || "",
    tropicalFreshWaterDraft: genInfo?.TROPICAL_FRESH_WATER_DRAFT || "",
    tpcTropicalFreshWaterDraft: genInfo?.TPC_TROPICAL_FRESH_WATER_DRAFT || "",
  };
}
